/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./image-uploader.vue?vue&type=template&id=2743be54&scoped=true&"
import script from "./image-uploader.vue?vue&type=script&lang=js&"
export * from "./image-uploader.vue?vue&type=script&lang=js&"
import style0 from "./image-uploader.vue?vue&type=style&index=0&id=2743be54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2743be54",
  null
  
)

export default component.exports